import { useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import Swal from "sweetalert2";
import Modal from 'react-modal';
import { getApi, postApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";


function GenerateInvoice() {
    const extrectArray = (response) => {
        if (Array.isArray(response?.data)) return response.data;
        if (Array.isArray(response?.Data)) return response.Data;
        return [];
    }
    const onToggle = () => setToggleActive(!toggleActive);
    const handleFormChange = (value, key) => {
        setFormData({ ...formData, [key]: value })
    }

    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedDocketNos, setSelectedDocketNos] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [termArr, setTermArr] = useState([]);
    const [poNo, setPoNo] = useState("");
    const [editIndex, setEditIndex] = useState(null);
    const [term, setTerm] = useState("");
    const [getCompany, setGetCompany] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [toggleActive, setToggleActive] = useState(false);
    const [getCustomer, setGetCustomer] = useState([]);
    const [previewData, setPreviewData] = useState([]);
    const [getBranch, setGetBranch] = useState([]);
    const [getMode, setGetMode] = useState([]);
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [formData, setFormData] = useState({
        branch: "",
        Company_Code: "",
        BookMode: "Monthly",
        customerType: "Single",
        fromDate: firstDayOfMonth,
        toDate: today,
        invoiceDate: today,
        BillParty: "Client-wise Bill",
        customer: "",
        mode: "",
        invoiceNo: ""
    });


    const loginData = JSON.parse(localStorage.getItem('Login'));
    useEffect(() => {
        if (loginData.Branch_Code !== "ALB") {
            setFormData((pre) => ({
                ...pre,
                branch: loginData?.Branch_Code,
            }))
        }
    }, [loginData])


    const fetchBranchData = async () => {
        try {
            const response = await getApi(
                `/Master/GetAllBranchData?Branch_Code=${loginData?.Branch_Code}`
            );

            let data = Array.isArray(response.Data) ? response.Data : [];

            // ✅ REMOVE ALB
            const filteredData = data.filter(
                (item) => item.Branch_Code !== 'ALB'
            );

            setGetBranch(filteredData);
        } catch (err) {
            console.error('Fetch Error:', err);
            setGetBranch([]);

        }
    };
    const fetchData = async (endpoint, setData) => {
        try {
            const response = await getApi(endpoint);
            console.log("API Response for", endpoint, response);  // 👀 Check here
            setData(extrectArray(response));
        } catch (err) {
            console.error('Fetch Error:', err);
        }
    };
    const fetchCompanyDetails = async () => {
        try {

            const response = await getApi(`/Master/GetCompanyDetails`);
            let data = Array.isArray(response.Data)
                ? response.Data
                : [];


            setGetCompany(data);

        } catch (err) {

            console.error('Fetch Company Details Error:', err);
        }
    };
    useEffect(() => {
        fetchData('/Master/getMode', setGetMode);
        fetchBranchData([]);
        fetchCompanyDetails();
    }, []);






    const fetchCustomerData = async () => {
        try {
            const response = await getApi(`/Master/getCustomerdata?Branch_Code=${formData.branch}&Description=${formData.Company_Code}`);
            setGetCustomer(Array.isArray(response.Data) ? response.Data : []);
        } catch (err) {
            console.error('Fetch Customer Error:', err);
            setGetCustomer([]); // Clear on error
        }
    };

    useEffect(() => {
        fetchCustomerData();
    }, [getBranch, formData.branch, getCompany, formData.Company_Code]);


    const loginCustomerCode = JSON.parse(localStorage.getItem("Login"))?.Customer_Code;
    const customerOptions =
        Array.isArray(getCustomer) && getCustomer.length > 0
            ? getCustomer
                .map(cust => ({
                    label: cust.Customer_Name,
                    value: cust.Customer_Code,

                }))
            : []


    const loginBranchCode = JSON.parse(localStorage.getItem("Login"))?.Branch_Code;
    const branchOptions =

        [
            ...getBranch.map(city => ({
                value: city.Branch_Code,   // adjust keys from your API
                label: city.Branch_Name,
            }))
        ] || [];



    const handleAddRow = (e) => {
        e.preventDefault();

        if (!term) {
            Swal.fire({
                icon: 'warning',
                title: 'Input Empty',
                text: 'Terms is required.',
                confirmButtonText: 'OK',
            });
            return;
        }
        if (editIndex !== null) {
            // update existing row
            const updated = [...termArr];
            updated[editIndex] = term;
            setTermArr(updated);
            setEditIndex(null);
        } else {
            // add new row
            setTermArr((prev) => [...prev, term]);
        }
        setTerm("");
    };

    const handleRowSelect = (index, docketNo, n) => {
        const already = selectedRows.includes(index);
        const updatedRows = already ? selectedRows.filter(i => i !== index) : [...selectedRows, index];
        if (already) {
            setSelectedDocketNos(selectedDocketNos.filter(docket => docket !== docketNo));

        } else {
            setSelectedDocketNos([...selectedDocketNos, docketNo]);

        }
        setSelectedRows(updatedRows);
        setSelectAll(updatedRows.length === n);
    };

    const handleSelectAll = () => {
        const newState = !selectAll;
        setSelectAll(newState);

        if (newState) {
            // Select All
            setSelectedRows(previewData.map((_, index) => index));                    // row index array
            setSelectedDocketNos(previewData.map(m => m.DocketNo));                   // all docket numbers
        } else {
            // Unselect All
            setSelectedRows([]);
            setSelectedDocketNos([]);
        }
    };

    const handlePreview = async (e) => {

        e.preventDefault();
        if (!formData.branch) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'You Can not preview data,please select the branch',
            });
            return;
        }
        if (formData.customerType === "Single" && !formData.customer)
            return Swal.fire("Warning", "If Customer Type is Single ,Customer Name is required", "warning");
        try {
            const payload = {
                ActionType: "Preview",                 // always preview here
                Branch_Code: formData.branch || null,  // from formData
                BillingCycle: formData.BookMode || null,
                FromDate: formData.fromDate || null,
                ToDate: formData.toDate || null,
                InvoiceDate: formData.invoiceDate || null,
                CustomerType: formData.customerType || null,
                GroupValue: String(formData.customer) || null,
                Mode_Code: formData.mode || null,
            };
            console.log(payload);
            const response = await postApi("/Smart/InvoiceGenerate",
                payload
            );
            console.log(response);
            if (response.status === 1) {
                setPreviewData(response.previewData);
                Swal.fire("Preview Ready", response.message, "success");
            } else {
                Swal.fire("Failed", response.message, "warning");
            }
        } catch (error) {
            Swal.fire("Error", error.message, "error");
        }
    };
    const handleGenerate = async (e) => {
        e.preventDefault();
        if (!formData.branch) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'You Can not generate invoice,please select the branch',
            });
            return;
        }
        if (formData.customerType === "Single" && !formData.customer)
            return Swal.fire("Warning", "If Customer Type is Single ,Customer Name is required", "warning");


        try {
            const payload = {
                ActionType: "Generate",                 // always preview here
                Branch_Code: formData.branch || null,  // from formData
                BillingCycle: formData.BookMode || null,
                FromDate: formData.fromDate?.toISOString().split("T")[0] || null,
                ToDate: formData.toDate?.toISOString().split("T")[0] || null,
                InvoiceDate: formData.invoiceDate?.toISOString().split("T")[0] || null,
                CustomerType: formData.customerType || null,
                GroupValue: String(formData.customer) || null,
                Mode_Code: formData.mode || null,
                InvoiceDescription1: termArr?.[0] || "",
                InvoiceDescription2: termArr?.[1] || "",
                InvoiceDescription3: termArr?.[2] || "",
                InvoiceDescription4: termArr?.[3] || "",
                InvoiceDescription5: termArr?.[4] || "",
                InvoiceDescription6: termArr?.[5] || "",
                PodNo: poNo || "",
                SelectedDockets: selectedDocketNos.join(",")
            };
            console.log(payload);
            const response = await postApi("/Smart/InvoiceGenerate",
                payload
            );
            console.log(response);
            if (response.status === 1) {
                Swal.fire("Generated", response.message, "success");
                setPreviewData([]);
            } else {
                Swal.fire("Failed", response.message, "warning");
            }
        } catch (error) {
            Swal.fire("Error", error.message, "error");
        }
    };


    return (
        <>
           <style>
                {`
    .table .tr-input td, .custom-th th {
    padding: 3px !important;
  }
    .table .tr-input td{
    height:36px
    }
`}
            </style>
            <div className="body">
                <div className="container1">
                    <form action="" >
                        <div className="fields2">

                            <div className="input-field2">
                                <label htmlFor="">Branch Name</label>
                                <Select
                                    options={branchOptions}
                                    value={branchOptions.find(opt => opt.value === formData.branch) || null}
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            branch: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    placeholder="Select Branch"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                />
                            </div>
                            <div className="input-field1">
                                <label htmlFor="">Company Name</label>
                                <Select
                                    className="blue-selectbooking"
                                    classNamePrefix="blue-selectbooking"
                                    options={getCompany.map((branch) => ({
                                        value: branch.Company_Code,
                                        label: branch.Company_Name,
                                    }))}
                                    value={
                                        formData.Company_Code
                                            ? {
                                                value: formData.Company_Code,
                                                label:
                                                    getCompany.find((b) => b.Company_Code === formData.Company_Code)
                                                        ?.Company_Name || "",
                                            }
                                            : null
                                    }
                                    onChange={(selected) =>
                                        setFormData({
                                            ...formData,
                                            Company_Code: selected ? selected.value : "",
                                        })
                                    }
                                    placeholder="Company Name"
                                    isSearchable={true}
                                    isClearable={false}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                />

                            </div>
                            <div className="input-field2">
                                <label htmlFor="">Customer Type</label>
                                <select value={formData.customerType} onChange={(e) => handleFormChange(e.target.value, "customerType")}>
                                    <option value="" disabled>Select Customer</option>
                                    <option value="All">All</option>
                                    <option value="Single">Single</option>
                                </select>
                            </div>
                            <div className="input-field1">
                                <label htmlFor="">Customer</label>
                                <Select
                                    options={customerOptions}
                                    value={customerOptions.find(opt => opt.value === formData.customer) || null}
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            customer: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                    placeholder="Select Customer"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                />


                            </div>

                            {/* <div className="input-field3">
                                <label htmlFor="">Booking Mode</label>
                                <select value={formData.BookMode} onChange={(e) => setFormData({ ...formData, BookMode: e.target.value })}>
                                    <option value="" disabled>Select Booking Mode</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Quarterly">Quarterly</option>
                                    <option value="Half Yearly">Half Yearly</option>
                                    <option value="Yearly">Yearly</option>
                                </select>
                            </div> */}

                            <div className="input-field3">
                                <label>Billing Type</label>
                                <select value={formData.BillParty} onChange={(e) => setFormData({ ...formData, BillParty: e.target.value })}>
                                    <option value="" disabled>Select Billing Type</option>
                                    <option value="Client-wise Bill">Client-wise Bill</option>
                                    <option value="Shipper-wise Bill">Shipper-wise Bill</option>
                                    <option value="Vendor-wise Bill">Vendor-wise Bill</option>
                                    <option value="Product-wise Bill">Product-wise Bill</option>
                                    <option value="Consignee-wise Bill">Consignee-wise Bill</option>

                                </select>
                            </div>

                            <div className="input-field3">
                                <label htmlFor="">From Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.fromDate}
                                    onChange={(date) => handleFormChange(date, "fromDate")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>

                            <div className="input-field3">
                                <label htmlFor="">To Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.toDate}
                                    onChange={(date) => handleFormChange(date, "toDate")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>

                            <div className="input-field3">
                                <label htmlFor="">Invoice Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.invoiceDate}
                                    onChange={(date) => handleFormChange(date, "invoiceDate")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>





                            <div className="input-field3">
                                <label htmlFor="">Mode</label>
                                <Select
                                    options={getMode.map(mode => ({
                                        value: mode.Mode_Code,   // adjust keys from your API
                                        label: mode.Mode_Name
                                    }))}
                                    value={
                                        formData.mode
                                            ? { value: formData.mode, label: getMode.find(c => c.Mode_Code === formData.mode)?.Mode_Name || "" }
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            mode: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                    placeholder="Select Mode"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                />

                            </div>
                        

                            <div className="input-field1">
                                <label htmlFor="">Invoice No</label>
                                <div style={{ display: "flex", gap: "5px" }}>
                                    <div className="docket-wrapper" style={{ flex: 1 }}>
                                        <input
                                            type="text"
                                            className="input"
                                            placeholder={toggleActive ? "Enter Invoice No" : "Auto"}
                                            disabled={!toggleActive}
                                            value={formData.invoiceNo}
                                            onChange={async (e) => {
                                                const value = e.target.value;

                                                setFormData(prev => ({
                                                    ...prev,
                                                    invoiceNo: value
                                                }));

                                                // Your API code...
                                            }}
                                        />

                                        <Toggle className="react-toggle"
                                            checked={toggleActive}
                                            onChange={() => setToggleActive(prev => !prev)}
                                            tabIndex={-1}
                                        />
                                    </div>
                                    <button className="ok-btn2" type="button" style={{ height: "35px", width: "50px" }} onClick={() => setModalIsOpen(true)}><i className="bi bi-layout-text-sidebar"></i></button>

                                </div>
                            </div>




                            <div className="bottom-buttons" style={{ marginTop: "23px", marginLeft: "10px" }}>
                                <button className="ok-btn" onClick={handleGenerate}> Generate </button>
                                <button className="ok-btn" onClick={handlePreview}>Preview</button>
                            </div>



                        </div>
                    </form>
                    {previewData.length > 0 && (<div className="table-container" style={{ margin: "0px" }}>
                        <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                            <thead className="table-info table-sm">
                                <tr>
                                    <th scope="col" className="w-60">
                                        <input type="checkbox" checked={selectAll}
                                            onChange={handleSelectAll} />
                                    </th>

                                    <th>Docket No</th>
                                    <th>Book Date</th>
                                    <th>Customer Code</th>
                                    <th>Customer Name</th>
                                    <th>Branch Name</th>
                                    <th>Mode Name</th>
                                    <th>Bill No</th>
                                    <th>Bill Generate</th>
                                    <th>Qty</th>
                                    <th>Actual Wt</th>
                                    <th>Charged Wt</th>
                                    <th>Rate Per Kg</th>
                                    <th>Rate</th>
                                    <th>Docket Chrgs</th>
                                    <th>IGST %</th>
                                    <th>IGST Amt</th>
                                    <th>CGST %</th>
                                    <th>CGST Amt</th>
                                    <th>SGST %</th>
                                    <th>SGST Amt</th>
                                    <th>City Name</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {previewData.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        <td scope="col" className="w-60">
                                            <input type="checkbox"  checked={selectedRows.includes(rowIndex)}
                                                onChange={() => handleRowSelect(rowIndex, row.DocketNo, previewData.length)} />
                                        </td>
                                        <td>{row.DocketNo}</td>
                                        <td>{row.BookDate}</td>
                                        <td>{row.Customer_Code}</td>
                                        <td>{row.Customer_Name}</td>
                                        <td>{row.Branch_Name}</td>
                                        <td>{row.Mode_Name}</td>
                                        <td>{row.BillNo}</td>
                                        <td>{row.BillGenerate ? "Yes" : "No"}</td>
                                        <td>{row.Qty}</td>
                                        <td>{row.ActualWt}</td>
                                        <td>{row.ChargedWt}</td>
                                        <td>{row.RatePerkg}</td>
                                        <td>{row.Rate}</td>
                                        <td>{row.DocketChrgs}</td>
                                        <td>{row.IGSTPer}</td>
                                        <td>{row.IGSTAMT}</td>
                                        <td>{row.CGSTPer}</td>
                                        <td>{row.CGSTAMT}</td>
                                        <td>{row.SGSTPer}</td>
                                        <td>{row.SGSTAMT}</td>
                                        <td>{row.City_Name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>)}

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen}
                        className="custom-modal-custCharges" contentLabel="Modal"
                        style={{
                            content: {
                                width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                whiteSpace: "nowrap",
                                height: "80%"

                            },
                        }}>
                        <div className="custom modal-content">
                            <div className="header-tittle">
                                <header>Invoice Descriptions
                                </header>
                            </div>

                            <div className='container2' style={{ borderRadius: "0px", paddingBottom: "0px", marginBottom: "0px" }}>
                                <form >
                                    <div className="fields2">
                                        {/* Select All */}
                                        <div className="input-field1">
                                            <label htmlFor="" >PO Numbers</label>
                                            <input
                                                type="tel"
                                                placeholder="Enter PO Numbers"
                                                className="input"
                                                value={poNo}
                                                onChange={(e) => setPoNo(e.target.value)}
                                            />
                                        </div>


                                    </div>

                                </form>


                            </div>
                            <div className='container2' style={{ borderRadius: "0px", padding: "10px", paddingTop: "0px", marginTop: "0px" }}>
                                <div className="table-container">
                                    <table className="table table-bordered table-sm">
                                        <thead className='table-info table-sm'>
                                            <tr className='custom-th'>
                                                <th>Invoice Descriptions</th>
                                                <th className="w-60">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-body">
                                            <tr className='tr-input'>
                                                <td >
                                                    <input type="text" placeholder="Enter discriptions"
                                                        className="input"
                                                        style={{ textAlign: "start" }} value={term}
                                                        onChange={(e) => setTerm(e.target.value)} />
                                                </td>
                                                <td>

                                                    <button className="ok-btn" style={{ width: "40px", height: "30px", margin: "0px 10px", marginTop: "3.2px", paddingTop: "2px", fontSize: "30px" }}
                                                        onClick={handleAddRow}>
                                                        <i className="bi bi-plus"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            {termArr.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{data}</td>
                                                    <td className="w-60">
                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                                            <button className='edit-btn'
                                                                onClick={() => {
                                                                    setTerm(data);
                                                                    setEditIndex(index);
                                                                }}>
                                                                <i className='bi bi-pen'></i>
                                                            </button>
                                                            <button onClick={() => {
                                                                setTermArr(termArr.filter((_, ind) => ind !== index));
                                                                setEditIndex(null);
                                                                setTerm('');
                                                            }}
                                                                className='edit-btn'><i className='bi bi-trash'></i></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='bottom-buttons'>
                                    <button type="button" className='ok-btn' onClick={() => { setModalIsOpen(false) }}>Submit</button>
                                    <button type="button" onClick={() => { setModalIsOpen(false) }} className='ok-btn'>Close</button>
                                </div>
                            </div>







                        </div>
                    </Modal >

                </div >
            </div >
        </>
    );
};

export default GenerateInvoice;